import { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { ButtonConfig } from "./HeaderButtons";
import AdminLayout from "../AdminLayout";

interface Props {
  headerMessage: string;
  children: ReactNode;
}

function EntityPageLayout({ children, headerMessage }: Props) {
  const intl = useIntl();
  const history = useHistory();

  const handleRedirect = () => {
    history.goBack();
  };

  const headerButtons: ButtonConfig[] = [
    {
      id: "back-button",
      text: intl.formatMessage({ id: "goBack" }),
      backgroundColor: "gray",
      handleClick: handleRedirect,
      className: "custom-back-button-class",
    },
  ];

  return (
    <AdminLayout
      header={<FormattedMessage id={headerMessage} />}
      headerButtons={headerButtons}
      containerClassName="usadmin-edit-entity-main-container"
    >
      {children}
    </AdminLayout>
  );
}

export default EntityPageLayout;
